<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
      <v-row>
        <v-col cols="12" md="8" lg="4">
          <v-text-field filled hide-details="" label="New Criteria name" v-model="criteriaName" :rules="requiredField" />
        </v-col>
        <v-col cols="12" md="12">
          <v-btn type="submit" color="primary" :disabled="!valid" rounded>Add New Criteria </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div class="display-2 text-center font-weight-medium my-10">Cost Criteria List</div>
    <v-row>
      <v-col cols="12" md="6" lg="4" v-for="cost in costList" :key="cost._id">
        <router-link class="text-decoration-none" :to="`/costs/${cost._id}`">
          <list-card :name="cost.name" />
        </router-link>
      </v-col>
    </v-row>
    <app-snackbar />
  </v-container>
</template>

<script>
import ListCard from '../components/common/ListCard.vue';
import { mapState } from 'vuex';
import { requiredField } from '../validations/FieldValidation';
import AppSnackbar from '../components/common/AppSnackbar.vue';

export default {
  components: { ListCard, AppSnackbar },
  data: () => ({
    criteriaName: '',
    valid: true,
    requiredField,
  }),
  computed: {
    ...mapState(['costList', 'isLoading']),
  },
  created() {
    this.$store.dispatch('getCostCriteria');
  },
  methods: {
    handleSubmit() {
      this.$store.dispatch('addNewCriteria', { name: this.criteriaName }).then(() => this.$refs.form.reset());
    },
  },
};
</script>

<style lang="scss" scoped></style>
